import { jbColors } from '../jbColors';
import { colors } from '@mui/material';

export const MuiAlert = {
  styleOverrides: {
    root: {
      padding: 0,
      fontSize: 11,
      lineHeight: '14px',
      borderRadius: '0',
      letterSpacing: 0,
      backgroundColor: jbColors.support.greenSmoke[10],
    },
    standardWarning: {
      backgroundColor: jbColors.support.greenSmoke[10],
      color: jbColors.support.greenSmoke[100],
      '& $icon': {
        color: colors.common.white,
        backgroundColor: jbColors.technical.amberYellow[80],
      },
    },
    icon: {
      marginRight: 12,
      padding: '7px 4px',
      opacity: 1,
      alignItems: 'center',
    },
    message: {
      padding: '10px 0',
      lineHeight: '16px',
    },
    action: {
      paddingLeft: 16,
      paddingRight: 20,
    },
  },
};
